import React from 'react';
import ReactDOM from 'react-dom';

import { T } from '../../../../common/locale/translate';
import {
  createAirportsObject,
  fetchFilterData,
  isFilterExpired,
  localstorageAvailable,
  numeralTranslation,
  replaceForeignCharacters
} from '../../services/services';
import { virtualAirports } from '../objects/consts';

export default class FlightAirport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      placeholder: [],
      active: false,
      airports: {},
      airports_list: [],
      chosen_airports: [],
      filterDataCacheTime: 900000 // in miliseconds
    };
  }

  componentDidMount = () => {
    document.addEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
    this.setInitialData();
  };

  componentWillUnmount = () => {
    document.removeEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  };

  render = () => {
    const { active, value } = this.state;
    const { title, filter_active } = this.props;
    return (
      <div
        className={`flight-airport select-wrapper animated-text-form extended ${
          active ? 'active' : ''
        } ${filter_active ? '' : 'filter-disabled'}`}
        ref={() => {
          this.returnSearchedValue = this.returnSearchedValue.bind(this);
        }}
      >
        <label className="animated-text-label">
          <span className="animated-text-label-name">{title}</span>
        </label>
        <i className="dropdown-icon fa fa-chevron-down" />
        <img
          className="input-icon"
          src="/img/icons/search/airport.svg"
          alt=""
        />
        <div className="desktop">
          <input
            type="text"
            value={value}
            className="animated-text-input"
            placeholder={this.formatedPlaceholder()}
            onChange={this.handleInputChange}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
          />
        </div>
        <div className="mobile">
          <label className="animated-text-label" onClick={this.handleOpen}>
            <span className="animated-text-input">
              {this.formatedPlaceholder()}
            </span>
          </label>
        </div>
        <div className="dropdown-menu">
          <div className="dropdown-input-wrapper mobile">
            <label className="animated-text-label" htmlFor="flight-from">
              {' '}
              <span className="animated-text-label-name">
                {this.props.title}
              </span>{' '}
            </label>
            <img
              className="dropdown-icon"
              src="/img/icons/search/airport.svg"
              alt=""
            />
            <input
              id="flight-from"
              type="text"
              value={value}
              className="animated-text-input"
              placeholder={this.formatedPlaceholder()}
              onChange={this.handleInputChange}
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
            />
          </div>
          <div className="reset-filter-custom mobile">
            <span onClick={this.handleReset} className="reset">
              <span> {T('clear')} </span>
            </span>
            <span onClick={this.handleClose} className="confirm">
              <span> {T('choose')} </span>
            </span>
          </div>
          <i className="fa fa-times close-icon" onClick={this.handleClose} />
          <div className="airports-list">
            <div className="dropdown-wrapper">{this.renderAirports()}</div>
          </div>

          <div className="airports-chosen">
            <div className="dropdown-header">
              <span> {T('selected_airports')} </span>
            </div>
            <div className="reset-filter-custom">
              <span onClick={this.handleReset} className="reset">
                <i className="fa fa-times reset-icon" />
                <span> {T('clear')} </span>
              </span>
              <span onClick={this.handleClose} className="confirm">
                <span> {T('choose')} </span>
              </span>
            </div>
            <div className="dropdown-wrapper">
              {this.renderChosenAirports()}
            </div>
          </div>
        </div>
      </div>
    );
  };

  setInitialData = () => {
    if (localstorageAvailable()) {
      if (isFilterExpired('airports', this.state.filterDataCacheTime)) {
        this.updateFilterSource();
      } else {
        const filter_data = JSON.parse(localStorage.getItem('airports_filter'));
        this.setState(
          {
            airports: filter_data.airports,
            airports_list: filter_data.airports_list
          },
          () => {
            this.setInitialChosenAirports();
          }
        );
      }
    } else {
      this.updateFilterSource();
    }
  };

  updateFilterSource = () => {
    fetchFilterData('airports_filter').then(
      response => {
        const filter_data = createAirportsObject(response.data);
        if (localstorageAvailable()) {
          localStorage.setItem('airports_filter', JSON.stringify(filter_data));
          localStorage.setItem(
            'airports_filter_last_update',
            new Date().getTime()
          );
        }
        this.setState(
          {
            airports: filter_data.airports,
            airports_list: filter_data.airports_list
          },
          () => {
            this.setInitialChosenAirports();
          }
        );
      },
      error => {
        console.log('Error when fetching regions filter', error);
      }
    );
  };

  setInitialChosenAirports = () => {
    const { departure_airports } = this.props;
    const { airports } = this.state;
    if (typeof departure_airports != 'undefined') {
      const chosen_airports = departure_airports
        .split(',')
        .filter(iata => airports[iata]);
      const placeholder = chosen_airports.map(
        iata => (airports[iata] ? airports[iata].name : '')
      );

      this.setState({ chosen_airports, placeholder });
    }
  };

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);
    if ((!domNode || !domNode.contains(event.target)) && this.state.active) {
      this.setState({ active: false, value: '' });
    }
  };

  handleCheckboxChange = (airportToRemove, event) => {
    let chosen_airports = this.state.chosen_airports;

    if (event.target.checked) {
      chosen_airports.push(event.target.value);
    } else {
      chosen_airports = chosen_airports.filter(
        airport_iata => airport_iata !== event.target.value
      );
    }
    if (airportToRemove) {
      chosen_airports = chosen_airports.filter(
        iata => iata !== airportToRemove
      );
    }

    let placeholder = chosen_airports.map(
      iata => this.state.airports[iata].name
    );
    this.setState({ chosen_airports, placeholder });
  };

  handleOpen = () => {
    let placeholder = this.state.chosen_airports.map(
      iata => this.state.airports[iata].name
    );
    this.setState({ active: true, placeholder: placeholder });
  };

  handleInputChange = event =>
    this.setState({
      value: event.target.value.replace(/[.*+?^${}()|[\]\\]/g, '')
    });

  handleClose = () => this.setState({ active: false, value: '' });

  handleReset = () => {
    this.state.chosen_airports.map(iata => {
      this.state.airports[iata].checked = false;
    });
    this.setState({ chosen_airports: [], placeholder: [] });
  };

  handleFocus = () => {
    this.setState({ active: true, placeholder: [] });
  };

  handleBlur = () => {
    let placeholder = this.state.chosen_airports.map(
      iata => this.state.airports[iata].name
    );
    this.setState({ placeholder });
  };

  formatedPlaceholder = () => {
    let placeholder = this.state.placeholder
      .join()
      .split(',')
      .join(', ');
    return this.state.placeholder.length > 4
      ? `${T('chosen')} ${this.state.placeholder.length} ${numeralTranslation(
          this.state.placeholder.length,
          [
            T('airport'),
            T('airports_first_plural'),
            T('airports_second_plural')
          ]
        )}`
      : placeholder;
  };

  renderAirports = () =>
    this.state.value !== ''
      ? this.renderSearchedAirports()
      : this.renderDefaultAirports();

  handleAirportRemove = iata => {
    let chosen_airports = this.state.chosen_airports.filter(
      aiport_iata => aiport_iata !== iata
    );
    let placeholder = chosen_airports.map(
      iata => this.state.airports[iata].name
    );
    this.setState({ chosen_airports, placeholder });
  };

  renderChosenAirports = () => {
    return this.state.chosen_airports.map((iata, i) => {
      let airport = this.state.airports[iata];
      return (
        <li key={i} className="item">
          <span>
            {' '}
            <i
              className="fa fa-times remove-icon"
              onClick={this.handleAirportRemove.bind(this, iata)}
            />{' '}
            {airport.name}{' '}
          </span>
        </li>
      );
    });
  };

  renderAirportsList = (airports, parentAirport) => {
    return airports
      .sort(
        (a, b) =>
          a.unicodeName < b.unicodeName
            ? -1
            : a.unicodeName > b.unicodeName
              ? 1
              : 0
      )
      .map((airport, i) => {
        let checked = this.state.chosen_airports.indexOf(airport.iata) > -1;
        return (
          <li key={i} className="item">
            <input
              type="checkbox"
              id={`${airport.iata}${i}${parentAirport}`}
              name="airport"
              value={airport.iata}
              onChange={this.handleCheckboxChange.bind(this, parentAirport)}
              checked={checked}
            />
            <label htmlFor={`${airport.iata}${i}${parentAirport}`}>
              {' '}
              {airport.name}{' '}
            </label>
          </li>
        );
      });
  };

  renderDefaultAirports = () => {
    const { chosen_airports } = this.state;
    let popular_airports = Object.keys(this.state.airports).length
      ? this.renderAirportsList(
          this.state.airports.countries['Popularne'],
          null
        )
      : '';
    let polish_airports = Object.keys(this.state.airports).length
      ? this.renderAirportsList(
          this.state.airports.countries['Polska'],
          virtualAirports.ALL_POL.iata
        )
      : '';
    let german_airports = Object.keys(this.state.airports).length
      ? this.renderAirportsList(
          this.state.airports.countries['Niemcy'],
          virtualAirports.ALL_GER.iata
        )
      : '';
    let other_airports = Object.keys(this.state.airports).length
      ? this.renderAirportsList(this.state.airports.countries['Inne'])
      : '';

    return (
      <div className="airports-wrapper">
        <div className="dropdown-header">
          <span> {T('popular')} </span>
        </div>
        <ul className="dropdown-wrapper">{popular_airports}</ul>
        <div className="dropdown-header">
          <div className="dropdown-header-checkbox-wrapper ">
            <input
              type="checkbox"
              id={`${virtualAirports.ALL_GER.iata}`}
              name="airport"
              value={virtualAirports.ALL_GER.iata}
              onChange={this.handleCheckboxChange.bind(this, null)}
              checked={
                chosen_airports.indexOf(virtualAirports.ALL_GER.iata) > -1
              }
            />
            <label htmlFor={`${virtualAirports.ALL_GER.iata}`}>
              {' '}
              <span> {T('germany')} </span>{' '}
            </label>
          </div>
        </div>
        <ul className="dropdown-wrapper">{german_airports}</ul>
        <div className="dropdown-header">
          <div className="dropdown-header-checkbox-wrapper">
            <input
              type="checkbox"
              id={`${virtualAirports.ALL_POL.iata}`}
              name="airport"
              value={virtualAirports.ALL_POL.iata}
              onChange={this.handleCheckboxChange.bind(this, null)}
              checked={
                chosen_airports.indexOf(virtualAirports.ALL_POL.iata) > -1
              }
            />
            <label htmlFor={`${virtualAirports.ALL_POL.iata}`}>
              {' '}
              <span> {T('poland')} </span>{' '}
            </label>
          </div>
        </div>
        <ul className="dropdown-wrapper">{polish_airports}</ul>
        <div className="dropdown-header">
          <span> {T('other')} </span>
        </div>
        <ul className="dropdown-wrapper">{other_airports}</ul>
      </div>
    );
  };

  renderSearchedAirports = () => {
    let query = this.state.value,
      chosen_airports = this.state.chosen_airports,
      search,
      searched_airports,
      airports;
    if (query.indexOf(',') > -1) {
      query = `(${query
        .replace(/\s/g, '')
        .split(',')
        .map(q => (q ? `\\?${q}\\?|` : ''))
        .join('')
        .slice(0, -1)})`;
      search = new RegExp(replaceForeignCharacters(query), 'i');
      searched_airports = this.state.airports_list.filter(airport =>
        search.test(airport.unicodeName)
      );
      searched_airports.map(elem => {
        if (chosen_airports.indexOf(elem.iata) == -1) {
          chosen_airports.push(elem.iata);
        }
      });
    } else {
      search = new RegExp(replaceForeignCharacters(query), 'i');
      searched_airports = this.state.airports_list.filter(airport =>
        search.test(airport.unicodeName)
      );

      if (
        searched_airports.length == 1 &&
        chosen_airports.indexOf(searched_airports[0].iata) == -1
      ) {
        search = new RegExp(`\\?${replaceForeignCharacters(query)}\\?`, 'i');
        if (search.test(searched_airports[0].unicodeName)) {
          chosen_airports.push(searched_airports[0].iata);
        }
      }
    }

    airports = this.renderAirportsList(searched_airports);

    return (
      <div>
        <div className="dropdown-header">
          <span> {T('airports')} </span>
        </div>
        <ul className="dropdown-wrapper">
          {airports.length ? airports : T('no_airports')}
        </ul>
      </div>
    );
  };

  returnSearchedValue = () => {
    return this.state.chosen_airports.length
      ? this.state.chosen_airports
      : false;
  };
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/flight-airport.js